<template>
  <div class="user-profile">
    <!-- User Icon (Click to Toggle Popup) -->
    <div class="user-profile__author-img" @click="togglePopup">
      <i class="fa-solid fa-user"></i>
    </div>

    <!-- Popup (Shown When popupVisible is True) -->
    <div v-if="popupVisible" class="user-profile__popup" ref="popup">
      <h3 class="user-profile__title">{{ apiData.name }} {{ apiData.lastName }} </h3>
      <h5 class="user-profile__subtitle">{{ $t("Merchant ID") }}: #{{ apiData.accountId }}</h5>

      <!-- Menu -->
      <ul class="user-profile__menu">
        <li>
          <router-link class="user-profile__menu-item" to="/settings">
            <div class="user-profile__menu-icon">
              <i class="fa-solid fa-gear"></i>
            </div>
            <div class="user-profile__menu-title">
              {{ $t("Settings") }}
            </div>
          </router-link>
        </li>
        <li>
          <router-link class="user-profile__menu-item" to="/support">
            <div class="user-profile__menu-icon green">
              <i class="fa-solid fa-headset"></i>
            </div>
            <div class="user-profile__menu-title">
              {{ $t("Support") }}
            </div>
          </router-link>
        </li>
        <li>
          <a class="user-profile__menu-item" @click="logout">
            <div class="user-profile__menu-icon red">
              <i class="fa-solid fa-right-from-bracket"></i>
            </div>
            <div class="user-profile__menu-title">
              {{ $t("Log Out") }}
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserProfile",
  data() {
    return {
      popupVisible: false
    };
  },
  computed: {
    apiData() {
      return this.$store.getters.getApiData;
    }
  },
  methods: {
    togglePopup() {
      this.popupVisible = !this.popupVisible;

      if (this.popupVisible) {
        document.addEventListener("click", this.handleOutsideClick);
      } else {
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
    handleOutsideClick(event) {
      // If the click is outside the popup and icon, close it
      if (
          this.$refs.popup &&
          !this.$refs.popup.contains(event.target) &&
          !event.target.closest(".user-profile__author-img")
      ) {
        this.popupVisible = false;
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
    logout() {
      this.$store.dispatch("getLogout")
    },
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  }
};
</script>
